import { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { useMetadataForm } from "./MetadataFormContext";

export function MetadataFormatName({ name, disabled, onClose }: { name: string; disabled?: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const { renameFormat } = useMetadataForm();
  const id = useId();
  const [draft, setDraft] = useState(name);
  const [invalid, setInvalid] = useState(false);
  const commit = () => {
    if (disabled || !renameFormat) return;
    const renamed = renameFormat(name, draft.trim());
    setInvalid(!renamed);
    if (renamed) onClose();
  };
  return (
    <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
      <DialogContent closeLabel={t("schedule.cancel")}>
        <DialogHeader>
          <DialogTitle>{t("metadata.format.renameTitle")}</DialogTitle>
          <DialogDescription>{t("metadata.renameFormatHelp")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
        <label htmlFor={id} className="text-xs font-medium">{t("metadata.format.name")}</label>
        <Input id={id} value={draft} disabled={disabled} className="min-w-0 font-mono text-xs"
          onFocus={event => event.target.select()}
          onChange={event => { setDraft(event.target.value); setInvalid(false); }}
          onKeyDown={event => {
            if (event.key === "Enter") { event.preventDefault(); commit(); }
          }} />
        {invalid && <p className="text-xs text-red-600">{t("metadata.invalidName")}</p>}
        </div>
        <DialogFooter>
        <Button type="button" variant="outline" size="sm" onClick={onClose}>{t("schedule.cancel")}</Button>
        <Button type="button" variant="outline" size="sm" disabled={disabled || draft.trim() === name} onClick={commit}>
          {t("metadata.rename")}
        </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
